import React from 'react'
import PropTypes from 'prop-types'
import EnhancedTable from './main'

import mainService from './service'

/**
 * @extends {React.Component<{headRows:arrayOf({
 *        label: string
 *        width: number
 *    }), rowTemplate:any, showSearchBox:boolean, preventFirstRender?:boolean, url:string}>}
 */
class TestTable extends React.PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      cargando: true,
      rows: [],
      totalRows: 0,
      busqueda: '',
      filters: {},
      otrosParametros: {},
      rowsPerPage: props.rowsPerPage || 10,
      currentPage: 0
    }
  }

  componentDidMount() {
    const { preventFirstRender, baseParams, url, useNest, useConta } = this.props
    if (preventFirstRender) {
      this.setState({
        cargando: false
      })
    } else {
      mainService
        .getData(
          { useNest, useConta },
          {
            url,
            params: {
              ...baseParams,
              busqueda: this.state.busqueda,
              rowsPerPage: this.state.rowsPerPage,
              currentPage: this.state.currentPage
            }
          }
        )
        .then(({ data }) => {
          this.setState({
            ...data,
            cargando: false
          })
        })
    }
  }

  afterReload = () => {
    const { baseParams, url, useNest, useConta } = this.props
    mainService
      .getData(
        { useNest, useConta },
        {
          url,
          params: {
            ...baseParams,
            ...this.state.otrosParametros,
            busqueda: this.state.busqueda,
            rowsPerPage: this.state.rowsPerPage,
            currentPage: this.state.currentPage
          }
        }
      )
      .then(({ data }) => {
        this.setState({
          ...data,
          cargando: false
        })
      })
  }

  reload = extraParams => {
    if (extraParams) {
      this.setState(
        {
          cargando: true,
          otrosParametros: extraParams
        },
        () => {
          this.afterReload()
        }
      )
    } else {
      this.setState(
        {
          cargando: true
        },
        () => {
          this.afterReload()
        }
      )
    }
  }

  clear = () => {
    this.setState({
      cargando: true,
      rows: [],
      totalRows: 0,
      busqueda: '',
      otrosParametros: {},
      rowsPerPage: this.props.rowsPerPage || 10,
      currentPage: 0
    })
  }

  handleBusquedaChange = busqueda => {
    const { baseParams, url, useNest, useConta } = this.props
    this.setState({
      cargando: true,
      busqueda: busqueda
    })

    mainService
      .getData(
        { useNest, useConta },
        {
          url,
          params: {
            ...baseParams,
            ...this.state.otrosParametros,
            busqueda: this.state.busqueda,
            rowsPerPage: this.state.rowsPerPage,
            currentPage: this.state.currentPage
          }
        }
      )
      .then(({ data }) => {
        this.setState({
          ...data,
          cargando: false
        })
      })
  }

  handleChangePage = newPage => {
    const { baseParams, url, useNest, useConta } = this.props
    this.setState({
      cargando: true,
      currentPage: newPage
    })

    mainService
      .getData(
        { useNest, useConta },
        {
          url,
          params: {
            ...baseParams,
            ...this.state.otrosParametros,
            ...this.state.filters,
            busqueda: this.state.busqueda,
            rowsPerPage: this.state.rowsPerPage,
            currentPage: newPage
          }
        }
      )
      .then(({ data }) => {
        this.setState({
          ...data,
          cargando: false
        })
      })
  }

  onFilterChange = filters => {
    const { baseParams, url, useNest, useConta } = this.props
    this.setState({
      cargando: true,
      filters: filters
    })

    mainService
      .getData(
        { useNest, useConta },
        {
          url,
          params: {
            ...baseParams,
            ...this.state.otrosParametros,
            ...filters,
            busqueda: this.state.busqueda,
            rowsPerPage: this.state.rowsPerPage
          }
        }
      )
      .then(({ data }) => {
        this.setState({
          ...data,
          cargando: false
        })
      })
  }

  render = () => {
    const { rows, totalRows, cargando, rowsPerPage, currentPage } = this.state
    const { title, headRows, rowTemplate, showSearchBox, useFilters, id } = this.props

    return (
      <EnhancedTable
        id={id}
        handleChangePage={this.handleChangePage}
        handleBusquedaChange={this.handleBusquedaChange}
        onFilterChange={this.onFilterChange}
        cargando={cargando}
        title={title}
        headRows={headRows}
        rowTemplate={rowTemplate}
        filas={rows}
        totalRows={totalRows}
        filasPorPagina={rowsPerPage}
        currentPage={parseFloat(currentPage)}
        showSearchBox={showSearchBox}
        useFilters={useFilters}
      />
    )
  }
}

TestTable.propTypes = {
  headRows: PropTypes.arrayOf(PropTypes.object),
  rowTemplate: PropTypes.any,
  showSearchBox: PropTypes.bool,
  preventFirstRender: PropTypes.bool,
  url: PropTypes.string
}

export default TestTable
